<template>
  <div>
    <table class="table table-breakdown">
      <thead>
        <tr>
          <th width="120"><a href="javascript:;">DATE</a></th>
          <th width="250"><a href="javascript:;">TEAM MEMBER</a></th>
          <th><a href="javascript:;">DESCRIPTION</a></th>
          <th width="100"><a href="javascript:;">HOURS</a></th>
        </tr>
      </thead>
      <tbody>
      <tr v-for="(record, index) in records"  :key="index">
        <td>
          <a href="javascript:;" @click="editTimesheet( index )">
          {{ record.session_date | toHumanDate('DD.MM.YY') }}
          </a>
        </td>
        <td>{{ record.user.full_name }}</td>
        <td v-html="nl2br(record.description)"></td>
        <td>{{ record.duration }}h
          <a href="javascript:;" class="float-right icon-trash" v-tooltip="'Delete Timesheet'" @click="confDelete( index )"></a>
        </td>
      </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="3">TOTAL</th>
          <th>{{ totalHours }}h</th>
        </tr>
      </tfoot>
    </table>
    <modal-edit v-model="showModalEdit" :job_name="job_name" :client_name="client_name" :timesheet="activeTimesheet" @timesheet-saved="onTimesheetSaved"></modal-edit>
  </div>
</template>

<script>
import ModalEdit from './ModalEdit'
import ServiceTimesheet from '@/services/timesheet'

export default {
  components: {
    ModalEdit
  },
  data () {
    return {
      showModalEdit: false,
      activeTimesheet: null,
      activeIndex: -1
    }
  },
  props: ['records', 'client_name', 'job_name'],
  watch: {
    records ( newVal ) {
      let self = this;
      if ( newVal ) {
        self.records = newVal;
      }
    }
  },
  computed: {
    totalHours () {
      let self = this, total = 0;
      for(let i in self.records) {
        total += parseFloat(self.records[i].duration);
      }
      return window.roundNumber(total, 2);
    }
  },
  created () {},
  mounted () {},
  methods: {
    init () {},
    editTimesheet ( index ) {
      let self = this;
      self.activeIndex = index;
      self.activeTimesheet = self.records[self.activeIndex] ? self.records[self.activeIndex] : null;
      self.showModalEdit = true;
    },
    onTimesheetSaved ( timesheet ) {
      let self = this;
      self.records.splice( self.activeIndex, 1, timesheet );
    },
    confDelete ( index ) {
      let self = this, item = self.records[index];
      self.$dialog
        .confirm('Are you sure you want to delete this record?', {
          html: true,
          loader: true,
          okText: "Yes, I'm sure",
          cancelText: "Cancel",
        })
        .then(dialog => {
          ServiceTimesheet.delete(item.id, () => {
            dialog.close();
            self.timesheets.splice(index, 1);
            self.$notify({
              type: 'success',
              text: 'Timesheet record is deleted'
            });
          });
        })
        .catch(() => {})
      ;
    },
    nl2br (val) {
      return window.nl2br(val);
    }
  }
}
</script>
